import { IChecklistItem, ChecklistItemStatus } from './../types/checklist_types';
import { IIndexable, key } from 'core-ts-types';

export class ChecklistItem implements IIndexable, IChecklistItem {
  id: key;
  type: string;
  title: string;
  status: ChecklistItemStatus = 'normal';
  detail: string;
  action_text?: string;
  action_url?: string;
  ordering: number = 1;
  isSelected: boolean = false;

  constructor(item: any) {
    _.merge(this, item);
  }

  static build(item: any) {
    return new ChecklistItem(item);
  }
}

angular.module('capability-ng-checklist').factory('ngChecklistItemBuilder', (): typeof ChecklistItem => {
  return ChecklistItem;
});



// WEBPACK FOOTER //
// ./app/lib/checklist/builders/checklist_item_builder.ts